import { CommonActions, createNavigationContainerRef } from '@react-navigation/native';
import type { ReviewSearchNavigationContext } from '../providers/SearchProvider';

export const navigationRef = createNavigationContainerRef<any>();

export type DetoxOpenRoute = 'review' | 'result';
export type DetoxOpenScreen = 'home' | 'reviews' | 'results' | 'profile' | 'admin';

export function navigateToDetoxRoute(route: DetoxOpenRoute, reviewId: number) {
  const tab = route === 'review' ? 'Reviews' : 'Results';
  const screen = route === 'review' ? 'ReviewDetail' : 'ResultDetail';

  navigationRef.dispatch(
    CommonActions.navigate({
      name: 'App',
      params: {
        screen: tab,
        params: {
          screen,
          params: { reviewId },
        },
      },
    })
  );
}

export function navigateToDetoxScreen(screen: DetoxOpenScreen) {
  const tabTargetByScreen: Record<DetoxOpenScreen, { screen: string; nestedScreen?: string }> = {
    home: { screen: 'Home' },
    reviews: { screen: 'Reviews', nestedScreen: 'ReviewList' },
    results: { screen: 'Results', nestedScreen: 'ResultsList' },
    profile: { screen: 'Profile', nestedScreen: 'ProfileMain' },
    admin: { screen: 'Admin' },
  };
  const target = tabTargetByScreen[screen];

  navigationRef.dispatch(
    CommonActions.navigate({
      name: 'App',
      params: {
        screen: target.screen,
        params: target.nestedScreen ? { screen: target.nestedScreen } : undefined,
      },
    })
  );
}

export function navigateToReviewSearchResult(
  navigationContext: ReviewSearchNavigationContext,
  reviewId: number,
  itemId: number,
  categoryName: string
) {
  if (!navigationRef.isReady()) {
    console.error('[Navigation] Cannot open search result before navigation is ready');
    return;
  }

  navigationRef.dispatch(
    CommonActions.navigate({
      name: 'App',
      params: {
        screen: navigationContext,
        params: {
          screen: 'ItemDetail',
          params: { reviewId, itemId, categoryName },
        },
      },
    })
  );
}
